module.exports = __webpack_public_path__ + "img/line.c2e6f446.svg";